export default "__VITE_ASSET__CCRls2rK__"